<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="关键字" prop="keywords">
        <el-input v-model="form.keywords" placeholder="关键字(多个关键字匹配用,号隔开)" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="在菜单显示">
        <el-switch
            v-model="form.showInMenu"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
          <div
              style="text-align: center;color: #909399;width: 99%;margin: 2px auto;margin-bottom: 24px; "
          >回复内容</div>
          <div  v-for="(item, index) in form.keywordReplies" :key="index">
            <el-alert :title=" 'NO.' + (index + 1)" style="margin: 10px;" type="info" :closable="false" />
            <el-form label-width="200px" size="small">
              <el-form-item label="回复内容" required>
                <el-select
                    v-model="item.replyContentId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素回复内容"
                    :remote-method="getReplyList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in replyList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="排序" required>
                <el-input-number v-model="item.sort" :min="0" :max="999" />
              </el-form-item>
              <el-form-item label="发送间隔(秒)" required>
                <el-input-number v-model="item.interval" :min="0" :max="999" />
              </el-form-item>
              <el-form-item>
                <div style="display: flex;justify-content: center;margin-top: 14px;">
                  <el-button
                      type="danger"
                      size="mini"
                      @click="removeList(index)"
                      v-if="index !== 0"
                  >-删除回复</el-button>
                </div>
              </el-form-item>
            </el-form>

          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加回复</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addKeyword,
  updateKeyword,
  getKeywordInfo,
  replyContentOption
} from '@/api/demo/helper/index'
import { getPosterList } from '@/api/demo/poster/index'
import { getToken } from '@/api/demo/classification/index'
export default {
  name: 'editHelperKeyword',
  data () {
    return {
      replyList: [],
      id: '', // id
      form: {
        keywords: '', // 关键字
        name: '', // 活动名称
        showInMenu: 0,
        keywordReplies: [
          {
            id: null, // 数量
            replyContentId: '',
            sort: '', // 奖品名称
            interval: 0
          }
        ]
      },
      replyOptionLoading: false,
      rules: {
        keywords: [
          {
            required: true,
            message: '请输入关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
    that.getReplyList()
  },
  methods: {
    removeList (index) {
      this.form.keywordReplies.splice(index, 1)
      this.form.keywordReplies.forEach((item, index) => {
        item.index = index
      })
    },
    addList () {
      this.form.keywordReplies.push({
        sort: 0,
        interval: 0
      })
    },
    getReplyList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyContentOption(query).then(res => {
        that.replyList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getInfo (id) {
      let that = this
      getKeywordInfo(id).then(res => {
        that.form = res
      })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        addKeyword(that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
          // that.$router.push("/demo/helper/keyword");
        })
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        updateKeyword(that.id, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
          // that.$router.push("/demo/helper/keyword");
        })
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
